import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { AgentService } from '../services/agent.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { SearchResponseIO } from 'src/app/models/search-responseIO';
import { SearchesTestApiStepFormComponent } from 'src/app/searches-test-rest-api/searches-test-api-step-form/searches-test-api-step-form.component';

@Component({
  selector: '',
  template: '',
})
export class AgentSearchHandler extends BaseSearchComponent<AgentService> implements OnInit {
  public searchName: string;
  public agentId;
  isAdvanceSearchDisplayed: boolean;

  constructor(
    public service: AgentService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, router, headerService);
    this.addLink = '/agent';
    this.service.isAuditButtonClicked = false;
    // this.isSearchFilteredByCriteria = true;
  }

  ngOnInit() {
    super.ngOnInit();
    if (
      this.settingService.getSessionStorageValue('ApplicationStatus') != null &&
      this.settingService.getSessionStorageValue('ApplicationStatus') != undefined
    ) {
      this.searchName = undefined;
    } else {
      this.searchName = 'SearchRecruitmentStatus';
    }
    this.service.forAuditSearchList = false;
    this.settingService.removeSessionStorage('AuditChanges');
    this.isAdvanceSearchDisplayed = false;
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: 'Search',
      },
    ];
  }

  protected getMoreOptionList(): any[] {
    return [
      // {
      //   // id: 'Edit',
      //   // link: '/agent/:id',
      // },
      {
        id: 'Delete',
        link: '/agent-search',
      },
      {
        id: 'Audit',
        link: '/audit-search/:id',
      },
      {
        id: 'Close',
        link: '/agent-search',
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    // header.title = 'Recruitment status';
    header.title = this.settingService.getLabelValue('recruitmentStatus');
    return header;
  }

  Edit_click(optionDetails: { button_id; link; ref_id }) {
    let link: string;

    link = optionDetails.link.toString().replace(':id', optionDetails.ref_id);
    this.router.navigate([link]);
  }

  public Audit_click(buttonClicked: { button_id: string; link: string; ref_id }) {
    this.service.id = buttonClicked.ref_id;
    setTimeout(() => {
      this.openModal('agentAuditPopUp');
      this.service.isAuditButtonClicked = true;
    }, 10);
  }

  closeAgentAuditPopUp() {
    this.closeModal('agentAuditPopUp');
    // this.service.isAuditButtonClicked = false;
  }

  // Audit_click(buttonClicked: { button_id: string; link: string; ref_id }) {
  //   this.service.id = buttonClicked.ref_id;
  //   this.agentId = this.service.id;
  //   this.searchName = 'SearchAuditResult';
  //   this.service.isAuditButtonClicked = true;
  //   setTimeout(() => {
  //     this.openModal('agentAuditPopUp');
  //   }, 5);
  // }

  // closeAgentAuditPopUp() {
  //   this.service.searchResponseIO = new SearchResponseIO();
  //   this.searchName = 'SearchRecruitmentStatus';
  //   this.agentId = null;
  //   this.closeModal('agentAuditPopUp');
  // }

  Delete_click(optionDetails: { button_id; link; ref_id }) {
    // console.log(optionDetails.ref_id, ' Delete');
    this.service.deleteAgent(optionDetails.ref_id).subscribe(
      (deleteResponse) => {
        if (deleteResponse['success'] == true) {
          this.warn(deleteResponse['message']);
          if (deleteResponse['message'] == 'Successful') {
            setTimeout(() => {
              this.reloadCurrentRoute();
            }, 10);
          }
        } else {
          this.warn(deleteResponse['message']);
        }
      },
      (error) => {
        console.log('Delete Agent load failed.');
        console.log('Error:', error);
      }
    );
  }

  Delete_All_click(optionDetails: { button_id; link; ref_id }) {
    this.service.deleteAgents(optionDetails.ref_id).subscribe(
      (deleteResponse) => {
        if (deleteResponse['success'] == true) {
          this.warn(deleteResponse['message']);
          if (deleteResponse['message'] == 'Successful') {
            setTimeout(() => {
              this.reloadCurrentRoute();
            }, 10);
          }
        } else {
          this.warn(deleteResponse['message']);
        }
      },
      (error) => {
        console.log('Delete Lead load failed.');
        console.log('Error:', error);
      }
    );
  }

  clickedAuditEvent(data) {
    this.service.isAuditButtonClicked = data;
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
  }
}
